import { render, staticRenderFns } from "./ContestLayout.vue?vue&type=template&id=f16b06ca&"
import script from "./ContestLayout.vue?vue&type=script&lang=js&"
export * from "./ContestLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports